export const company = {
  name: "Nabh Technologies",
  tagline: "The Rooter In Technology",
  headline: "Simply Exceptional Software Engineering.",
  headlineSub:
    "Proven IT consulting and custom software development for complex business challenges - ensuring long-term success.",
  description:
    "Nabh Technologies is an IT consultancy and product company in Indore, India. We design and build web apps, mobile apps, cloud solutions, and EdTech platforms for schools and enterprises.",
  logos: {
    full: "/nabh-logo-full.png",
    icon: "/nabh-logo-icon.png",
  },
  email: "Info@nabhtech.com",
  hrEmail: "hr@nabhtech.com",
  emails: [
    { label: "General inquiries", address: "Info@nabhtech.com" },
    { label: "HR & careers", address: "hr@nabhtech.com" },
  ],
  phone: "+91 90390 27741",
  phoneTel: "+919039027741",
  address: "166, Ahilya Nagar, Scheme No 51, Indore, Madhya Pradesh 452006",
  hours: "Monday - Friday: 10 AM - 7 PM",
  closed: "Sunday: Closed",
  map: {
    lat: 22.7443264,
    lng: 75.8373666,
    zoom: 15,
    placeId: "0x3962fd83c9f1df61:0xb76971874ae23a86",
  },
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.27!2d75.8373666!3d22.7443264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fd83c9f1df61%3A0xb76971874ae23a86!2sNabh%20Technologies!5e0!3m2!1sen!2sin!4v1748534400!5m2!1sen!2sin",
  mapLink:
    "https://www.google.com/maps/dir//Nabh+Technologies,+166,+Ahilya+Nagar,+Scheme+No+51,+Indore,+Madhya+Pradesh+452006/@22.7443264,75.8373666,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3962fd83c9f1df61:0xb76971874ae23a86!2m2!1d75.8373666!2d22.7443264?entry=ttu",
  social: {
    linkedin: "https://www.linkedin.com/company/nabhtech/",
    facebook: "https://www.facebook.com/people/Nabh-Technologies/100089832285375/",
  },
};

export const navLinks = [
  { title: "Home", path: "/" },
  { title: "Products", path: "/product" },
  { title: "Services", path: "/ourServices" },
  { title: "About", path: "/about_us" },
  { title: "Contact", path: "/contact" },
];

export const heroTrustPills = [
  { label: "Local", detail: "partnership" },
  { label: "Global", detail: "standards" },
  { label: "Flawless", detail: "execution" },
];

export const heroStats = [
  { value: 15, suffix: "+", label: "Projects Delivered" },
  { value: 5, suffix: "+", label: "Years in Business" },
  { value: 20, suffix: "+", label: "Happy Clients" },
  { value: 10, suffix: "+", label: "Tech Experts" },
];

export const aboutIntro = {
  eyebrow: "Who we are",
  title: "Engineering digital experiences",
  highlight: "with vision, insight, and experience",
  body: "We believe in building a future where people, process, and technology drive lasting change. Whatever we do is rooted in customer-centricity - tailored solutions that enhance performance and secure competitive advantages.",
  cta: { label: "Learn more about us", path: "/about_us" },
};

export const serviceCategories = [
  {
    title: "Software Engineering",
    items: [
      "Web Development",
      "Mobile App Development",
      "Product Development",
      "Custom Software",
      "E-commerce Solutions",
      "API & Integrations",
      "Testing & QA",
    ],
  },
  {
    title: "Design & Experience",
    items: ["UI/UX Design", "User Research", "Prototyping", "Design Systems"],
  },
  {
    title: "Cloud & Data",
    items: ["Cloud Consulting", "DevOps", "Data Engineering", "AI & ML"],
  },
  {
    title: "IT Support",
    items: ["Data Security", "24/7 IT Support", "Maintenance", "Monitoring"],
  },
];

export const valuePillars = [
  {
    title: "Agile Approach",
    description:
      "Improve digital responsiveness with agile delivery, transparent sprints, and demos that keep your roadmap on track.",
  },
  {
    title: "Reduced Time to Market",
    description:
      "Gain a competitive edge with solutions delivered at speed - from MVP to production without sacrificing quality.",
  },
  {
    title: "Technological Excellence",
    description:
      "Stay ahead with modern stacks: Java, React, cloud, and AI - chosen for scalability and maintainability.",
  },
  {
    title: "End-User Satisfaction",
    description:
      "Meaningful experiences built to boost engagement and conversions for education, SaaS, and enterprise users.",
  },
  {
    title: "Security & Support",
    description:
      "Security best practices, monitoring, and reliable support so your software stays stable after launch.",
  },
];

export const successStories = [
  {
    id: "01",
    industry: "EdTech",
    title: "Digital learning platform for schools at scale",
    summary:
      "Built assessment and analytics tools with role-based access, helping institutions run tests and track outcomes online.",
    metrics: [
      { value: "2x", label: "Faster test cycles" },
      { value: "100%", label: "Cloud-ready" },
    ],
    link: "https://dlm.nabhtech.com",
    cta: "View Nabh DLM",
  },
  {
    id: "02",
    industry: "Education",
    title: "School management system for daily operations",
    summary:
      "Streamlined admissions, academics, fees, and communication in one platform for administrators and parents.",
    metrics: [
      { value: "40%", label: "Less admin time" },
      { value: "24/7", label: "Access" },
    ],
    link: "https://blossomsms.nabhtech.com/sms/login",
    cta: "View Nabh SMS",
  },
  {
    id: "03",
    industry: "Media",
    title: "Streaming experience for modern audiences",
    summary:
      "Delivered a responsive catalog and playback experience focused on performance and user engagement.",
    metrics: [
      { value: "Fast", label: "Page loads" },
      { value: "Mobile", label: "First design" },
    ],
    link: "https://www.cinepluse.in/",
    cta: "View CinePluse",
  },
  {
    id: "04",
    industry: "SaaS",
    title: "Operations suite for teams and sales",
    summary:
      "Integrated employee, task, and sales workflows with dashboards that keep leadership aligned.",
    metrics: [
      { value: "1", label: "Unified hub" },
      { value: "Multi", label: "Role access" },
    ],
    link: "https://four-dots-prd-web-560711701817.asia-southeast1.run.app/login",
    cta: "View FourDots",
  },
];

export const services = [
  {
    id: "web",
    title: "Web Development",
    description:
      "Scalable web platforms and well-tested applications ready to handle growth - from MVPs to enterprise portals.",
    icon: "web",
  },
  {
    id: "mobile",
    title: "Mobile App Development",
    description:
      "Native-quality iOS and Android experiences with React Native and modern backend integrations.",
    icon: "mobile",
  },
  {
    id: "product",
    title: "Product Development",
    description:
      "End-to-end product engineering: discovery, prototyping, MVP, and scaling with clear milestones.",
    icon: "product",
  },
  {
    id: "uiux",
    title: "UI/UX Design",
    description:
      "User-centered interfaces that balance aesthetics, accessibility, and conversion for your business goals.",
    icon: "design",
  },
  {
    id: "cloud",
    title: "Cloud Consulting",
    description:
      "Architecture reviews, cost optimization, and secure deployments on AWS, Azure, and GCP.",
    icon: "cloud",
  },
  {
    id: "security",
    title: "Data Security & IT Support",
    description:
      "Security best practices, monitoring, and ongoing IT support to keep your systems reliable.",
    icon: "security",
  },
];

export const products = [
  {
    name: "Nabh DLM",
    tagline: "Digital Learning & Assessment",
    description:
      "An all-in-one platform for schools, teachers, and students to create, conduct, and analyze tests with smart automation and insightful reports.",
    link: "https://dlm.nabhtech.com",
    features: ["Online assessments", "Analytics dashboards", "Role-based access"],
  },
  {
    name: "Nabh SMS",
    tagline: "School Management System",
    description:
      "Advanced school management software to streamline admissions, academics, fees, and daily operations with automation.",
    link: "https://blossomsms.nabhtech.com/sms/login",
    features: ["Student records", "Admin workflows", "Parent communication"],
  },
  {
    name: "CinePluse",
    tagline: "Premium Movie Streaming",
    description:
      "A modern streaming experience to discover and watch movies with a clean interface built for performance and engagement.",
    link: "https://www.cinepluse.in/",
    features: ["Movie catalog", "Smooth playback", "Responsive web app"],
  },
  {
    name: "FourDots",
    tagline: "Business Operations Suite",
    description:
      "An integrated app for employee, task, sales, and management workflows - helping teams plan work, track progress, and stay aligned.",
    link: "https://four-dots-prd-web-560711701817.asia-southeast1.run.app/login",
    features: ["Employee management", "Tasks & sales", "Role-based dashboards"],
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Discovery Workshop",
    description:
      "Collaborative workshops to explore goals, users, and scope - aligning business value before we build.",
  },
  {
    step: "02",
    title: "Predictive Planning",
    description:
      "Clear milestones, estimates, and risk planning so delivery stays predictable and transparent.",
  },
  {
    step: "03",
    title: "IA & UX/UI Design",
    description:
      "Wireframes and prototypes that validate flows, accessibility, and conversion before development.",
  },
  {
    step: "04",
    title: "Development",
    description:
      "Agile sprints with demos, code reviews, and quality checks using modern, maintainable stacks.",
  },
  {
    step: "05",
    title: "Testing",
    description:
      "Functional, regression, and security-focused testing for reliable releases your users can trust.",
  },
  {
    step: "06",
    title: "Maintenance",
    description:
      "Deployment, monitoring, and ongoing support to keep your product secure and performing.",
  },
];

export const techTabs = [
  { id: "frontend", label: "Frontend", categoryIndex: 2 },
  { id: "backend", label: "Backend", categoryIndex: 0 },
  { id: "ai", label: "AI & ML", categoryIndex: 1 },
  { id: "cloud", label: "Cloud & DevOps", categoryIndex: 3 },
];

export const techStack = {
  subtitle:
    "From enterprise Java backends to AI-powered features - we use proven tools for scalable, maintainable products.",
  categories: [
    {
      name: "Java & backend",
      items: [
        "Java",
        "Spring Boot",
        "Spring Framework",
        "Hibernate / JPA",
        "Kotlin",
        "Maven & Gradle",
        "REST APIs",
        "Microservices",
      ],
    },
    {
      name: "AI & machine learning",
      items: [
        "Python",
        "TensorFlow",
        "PyTorch",
        "scikit-learn",
        "OpenAI API",
        "LangChain",
        "Hugging Face",
        "LLMs & NLP",
        "Pandas & NumPy",
      ],
    },
    {
      name: "Frontend & mobile",
      items: [
        "React",
        "Angular",
        "Vue.js",
        "TypeScript",
        "React Native",
        "Next.js",
        "Material UI",
      ],
    },
    {
      name: "Data, cloud & DevOps",
      items: [
        "PostgreSQL",
        "MongoDB",
        "Redis",
        "AWS",
        "Google Cloud (GCP)",
        "Docker",
        "Kubernetes",
        ".NET",
        "FastAPI",
      ],
    },
  ],
};

export const testimonials = [
  {
    quote:
      "Nabh Technologies delivered our school platform on time with a team that understood education workflows deeply.",
    author: "School Administrator",
    role: "Education Client",
  },
  {
    quote:
      "Professional communication, clean code, and a product we are proud to show our customers.",
    author: "Product Owner",
    role: "SaaS Startup",
  },
  {
    quote:
      "From UI design to deployment, they handled everything and stayed responsive throughout.",
    author: "Operations Manager",
    role: "Enterprise",
  },
];

export const aboutValues = [
  {
    title: "Innovation",
    description: "We adopt modern tools and practices to solve real business problems.",
  },
  {
    title: "Quality",
    description: "Testing, reviews, and maintainable code are non-negotiable in our delivery.",
  },
  {
    title: "Partnership",
    description: "We work as an extension of your team with clear communication and honesty.",
  },
  {
    title: "Impact",
    description: "Every release should move measurable outcomes for your users and business.",
  },
];

export const team = [
  { name: "Leadership", role: "Strategy & Delivery", initials: "NT" },
  { name: "Engineering", role: "Full-Stack Development", initials: "EN" },
  { name: "Design", role: "UI/UX & Brand", initials: "UX" },
  { name: "Support", role: "Client Success", initials: "CS" },
];

export const footerLinks = {
  services: services.map((s) => ({ title: s.title, link: "/ourServices" })),
  company: [
    { title: "About Us", link: "/about_us" },
    { title: "Contact", link: "/contact" },
    { title: "Products", link: "/product" },
    { title: "Services", link: "/ourServices" },
  ],
  legal: [
    { title: "Privacy Policy", link: "/privacy-policy" },
    { title: "Terms & Conditions", link: "/term-condition" },
    { title: "Refund Policy", link: "/refund-policy" },
    { title: "Cancellation Policy", link: "/cancellation-policy" },
    { title: "Disclaimer", link: "/disclaimer" },
  ],
};

export const site = {
  /** Set REACT_APP_SITE_URL in Netlify for production canonical URLs */
  url: (typeof process !== "undefined" && process.env.REACT_APP_SITE_URL) || "https://nabhtech.com",
  locale: "en_IN",
  twitterHandle: "",
};

export const seo = {
  default: {
    title: "Nabh Technologies | Web & Mobile App Development Indore",
    description:
      "Nabh Technologies builds web apps, mobile apps, cloud solutions, and EdTech products (Nabh DLM, Nabh SMS) from Indore, Madhya Pradesh, India.",
    path: "/",
  },
  home: {
    title: "Nabh Technologies | IT Solutions & EdTech Software",
    description:
      "Custom web and mobile development, cloud consulting, and EdTech products including Nabh DLM, Nabh SMS, CinePluse, and FourDots. Based in Indore, India.",
    path: "/",
  },
  about: {
    title: "About Us | Nabh Technologies Indore",
    description:
      "Meet Nabh Technologies: our mission, team, and values. We partner with schools, startups, and enterprises on software delivery from Indore, India.",
    path: "/about_us",
  },
  services: {
    title: "Software Development Services | Nabh Technologies",
    description:
      "Web development, mobile apps, UI/UX design, product engineering, cloud consulting, AI/ML, and IT support for businesses in India and worldwide.",
    path: "/ourServices",
  },
  product: {
    title: "EdTech & SaaS Products | Nabh Technologies",
    description:
      "Explore Nabh DLM, Nabh SMS, CinePluse, and FourDots - platforms for education, streaming, and business operations built by Nabh Technologies.",
    path: "/product",
  },
  contact: {
    title: "Contact Nabh Technologies | Indore",
    description:
      "Contact Nabh Technologies for project inquiries, support, or careers. Phone +91 90390 27741. Email Info@nabhtech.com. Office in Indore, MP.",
    path: "/contact",
  },
  notFound: {
    title: "Page Not Found | Nabh Technologies",
    description: "The page you requested could not be found on nabhtech.com.",
    path: "",
    noindex: true,
  },
  legal: {
    privacy: {
      title: "Privacy Policy | Nabh Technologies",
      path: "/privacy-policy",
    },
    terms: {
      title: "Terms & Conditions | Nabh Technologies",
      path: "/term-condition",
    },
    refund: {
      title: "Refund Policy | Nabh Technologies",
      path: "/refund-policy",
    },
    cancellation: {
      title: "Cancellation Policy | Nabh Technologies",
      path: "/cancellation-policy",
    },
    disclaimer: {
      title: "Disclaimer | Nabh Technologies",
      path: "/disclaimer",
    },
  },
};

